import { DatasetSchema } from '../types/schema';

export function getDataTypeTitle(dataType: DatasetSchema['data_type']) {
  switch (dataType) {
    case 'chat':
      return 'Chat';
    case 'llm':
      return 'LLM';
    case 'kv':
      return 'Key-Value';
  }
}
